import { FILE_UPLOAD_STARTED, FILE_UPLOAD_PRELOADED, FILE_UPLOAD_FAILURE, FILE_UPLOAD_PROGRESS } from 'EmailEditorUI/redux/actions/LayoutBuilderActionTypes';
import { UPDATE_ELEMENT_DATA, UPDATE_MULTIPLE_FIELDS_ON_ELEMENT, REMOVE_ELEMENT } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
export function fileUploadsReducer(draft = {}, action) {
  switch (action.type) {
    case FILE_UPLOAD_PRELOADED:
      {
        draft[action.moduleId].tempUrl = action.tempUrl;
        return draft;
      }
    case FILE_UPLOAD_STARTED:
      {
        draft[action.moduleId] = {
          progress: 0,
          tempUrl: ''
        };
        return draft;
      }
    case FILE_UPLOAD_PROGRESS:
      {
        if (!draft[action.moduleId]) {
          return draft;
        }
        draft[action.moduleId].progress = action.loaded / action.total * 100;
        return draft;
      }
    case REMOVE_ELEMENT:
    case UPDATE_ELEMENT_DATA:
    case UPDATE_MULTIPLE_FIELDS_ON_ELEMENT:
      {
        if (draft[action.id]) {
          if (draft[action.id].tempUrl) {
            window.URL.revokeObjectURL(draft[action.id].tempUrl);
          }
          delete draft[action.id];
          return draft;
        }
        return draft;
      }
    case FILE_UPLOAD_FAILURE:
      {
        if (!draft[action.moduleId]) {
          return draft;
        }
        if (draft[action.moduleId].tempUrl) {
          window.URL.revokeObjectURL(draft[action.moduleId].tempUrl);
        }
        delete draft[action.moduleId];
        return draft;
      }
    default:
      return draft;
  }
}
export default fileUploadsReducer;